export function urlCombine(absoluteUrl: string, relativeUrl: string) {
  return new URL(relativeUrl, absoluteUrl).href;
}

export function setUrlParam(url: string, param: string, value: string): string {
  const sep = url.indexOf('?') >= 0 ? '&' : '?';
  url = url.replace(new RegExp(param + '=.*?(&|$)', 'g'), '');
  const encodedValue =
    value === null || value === undefined ? '' : encodeURIComponent(value);
  url = url + sep + param + '=' + encodedValue;
  url = url.replace('&&', '&');
  url = url.replace('?&', '?');
  return url;
}

export function setUrlParams(url: string, keyValueCollection: any) {
  let baseUrl = url;
  for (const key in keyValueCollection) {
    if (Object.hasOwn(keyValueCollection, key))
      baseUrl = setUrlParam(baseUrl, key, keyValueCollection[key]);
  }
  return baseUrl;
}
